import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dialog-box"
}
const _hoisted_2 = { class: "dialog-action" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "l-modal"
}

import { ref, watch } from "vue";
import CommonButton from "./CommonButton.vue";
import { Field } from "vee-validate";

// APIを公開
export type DialogProps = {
  modelValue: boolean;
  message: string;
  button: string;
  subMessage?: string;
  showTextField?: boolean;
  placeFolder?: string;
  submitUrl?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ComfirmDialog',
  props: {
    modelValue: { type: Boolean },
    message: {},
    button: {},
    subMessage: {},
    showTextField: { type: Boolean },
    placeFolder: {},
    submitUrl: {}
  },
  emits: ["apply", "update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

__expose({
  openDialog,
});

const url = ref("");
// dialogの参照を保持する変数
const dialog = ref<HTMLDialogElement | null>(null);
const loading = ref(false);
// const open = ref(false);
const emit = __emit;
const props = __props;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const click = async ($event: any) => {
  if (!$event || !$event.target) {
    // escapeボタンでは閉じないようにする
    emit("update:modelValue", false);
    dialog?.value?.close();
  }
};

// 外部に公開するAPI。ダイアログを開いて、終了
function openDialog() {
  dialog?.value?.showModal();
  url.value = props.submitUrl || "";
}

// ボタンが押されたときに呼ばれるコールバック
async function onDialogAction(action: boolean) {
  if (action) {
    loading.value = true;
    emit("apply", url.value);
    loading.value = false;
    dialog?.value?.close();
  } else {
    dialog?.value?.close();
  }
  emit("update:modelValue", false);
}

function setPlaceFolder() {
  return props.placeFolder || "";
}

watch<string | undefined>(
  () => props.submitUrl,
  (newValue) => {
    if (newValue) {
      url.value = newValue;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("dialog", {
      ref_key: "dialog",
      ref: dialog,
      class: "dialog",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (click($event))),
      style: _normalizeStyle([_ctx.modelValue ? 'z-index: 999;' : 'z-index: 0; visibility: hidden;'])
    }, [
      (_ctx.modelValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onDialogAction(false)))
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", null, _toDisplayString(_ctx.message), 1 /* TEXT */),
              (_ctx.subMessage)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.subMessage), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_ctx.showTextField)
                ? (_openBlock(), _createBlock(_unref(Field), {
                    key: 1,
                    type: "text",
                    modelValue: url.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((url).value = $event)),
                    name: "url",
                    placeholder: setPlaceFolder(),
                    class: "text-field",
                    tabindex: "0"
                  }, null, 8 /* PROPS */, ["modelValue", "placeholder"]))
                : _createCommentVNode("v-if", true),
              (!loading.value && !_ctx.showTextField)
                ? (_openBlock(), _createBlock(CommonButton, {
                    key: 2,
                    data: {
            status: !loading.value ? 0 : 2,
            button: _ctx.button,
          },
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (!loading.value ? onDialogAction(true) : ''))
                  }, null, 8 /* PROPS */, ["data"]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode("テキストフィールド表示あり"),
              (!loading.value && _ctx.showTextField)
                ? (_openBlock(), _createBlock(CommonButton, {
                    key: 3,
                    data: {
            status: !loading.value && _ctx.showTextField && url.value ? 0 : 2,
            button: _ctx.button,
          },
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (!loading.value && _ctx.showTextField && url.value ? onDialogAction(true) : ''))
                  }, null, 8 /* PROPS */, ["data"]))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ], 4 /* STYLE */),
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.modelValue ? 'l-modal__bg' : ''])
          }, null, 2 /* CLASS */)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})